import { adaptListOfNamesToCheckboxOptions } from '@/helpers';
import { notationNumberRegex } from '@/assets/validators/regexValidator';
import beamlineSpecification from '@/json/beamlineSpecification';

const evaporationOptions = {
  first: { prepend: 'Material' },
  second: {
    prepend: 'Thickness',
    append: 'nm',
    type: 'text',
  },
};

const reactionChamberOptions = {
  first: {
    prepend: 'Gas type',
    type: 'text',
    model: 'gas_type',
  },
  second: {
    prepend: 'Gas pressure',
    append: 'mbar',
    type: 'text',
    model: 'gas_pressure',
    prop: {
      formatter(value) {
        const { target } = window.event;
        const testValue = value.replace(',', '.').trim();
        return notationNumberRegex.regex.test(testValue)
          ? value : value.substr(0, target.selectionEnd - 1) + value.substr(target.selectionEnd);
      },
    },
  },
  third: {
    prepend: 'Reaction temperature',
    append: 'K',
    type: 'number',
    model: 'reaction_temperature',
    prop: {
      min: beamlineSpecification.endStationASpecification.reaction_chamber_temperature.from,
      max: beamlineSpecification.endStationASpecification.reaction_chamber_temperature.to,
    },
  },
};

const photonPolarisation = [
  {
    name: 'Linear horizontal',
    buttonVariant: 'outline-info',
  },
  {
    name: 'Circular / Eliptical',
    buttonVariant: 'outline-info',
  },
  {
    name: 'Linear vertical',
    buttonVariant: 'outline-info',
  },
];

const cryogenicLiquids = adaptListOfNamesToCheckboxOptions([
  'None', 'LN2', 'LHe',
]);

const detectionModes = [
  {
    name: 'Resonance Photoelectron Spectroscopy (ResPES)',
    buttonVariant: 'outline-info',
  },
  {
    name: 'Soft X-ray Angle Resolved Photoelectron Spectroscopy (SX-ARPES)',
    buttonVariant: 'outline-info',
  },
  {
    name: 'In Expert Commissioning Access: Spin Resolved Angle Resolved Photoelectron Spectroscopy (SR-ARPES)',
    buttonVariant: 'outline-info',
  },
  {
    name: 'X-ray Photoelectron Spectroscopy (XPS)',
    buttonVariant: 'outline-info',
  },
  {
    name: 'Circular Dichroic Angle Resolved Photoelectron Spectroscopy (CD-ARPES)',
    buttonVariant: 'outline-info',
  },
  {
    name: 'Total Fluorescence Yield (TFY)',
    buttonVariant: 'outline-info',
  },
  {
    name: 'Total Electron Yield (TEY)',
    buttonVariant: 'outline-info',
  },
];

export {
  evaporationOptions,
  reactionChamberOptions,
  photonPolarisation,
  cryogenicLiquids,
  detectionModes,
};
